<template>
    <div>
        <PmisTitle title="Tehnološka igralnica"></PmisTitle>
        <PmisHeader></PmisHeader>
        <PmisIntro id="o_igralnici"></PmisIntro>
        <PmisIgrala id="igrala"></PmisIgrala>
        <PmisPresentationContainer name="thingsBoard" idx="1"></PmisPresentationContainer>
        <PmisPresentationContainer name="orange" idx="2"></PmisPresentationContainer>
        <PmisPresentationContainer name="wso2" idx="3"></PmisPresentationContainer>
        <div class="color-group" v-on:click="changeTheme(item)" v-bind:key="item.text"
             v-for="item in getSolutions">
            <PmisPresentationContainer :name="item.name"></PmisPresentationContainer>
        </div>
<!--                <PmisPresentationContainer name="thingsBoard"></PmisPresentationContainer>-->
        <dynamic-modal-dialog/>
        <add-new-solution-modal-dialog/>
        <single-element-modal-dialog/>
        <static-modal-dialog/>

        <!-- makrdonw text area component related to the library StackEdit-->
        <textarea id="makrdown-content" style="display: none;"></textarea>

        <markdown-modal-dialog/>
    </div>
</template>

<script>
    import PmisHeader from "./title/PmisHeader";
    import PmisTitle from "./title/PmisTitle";
    import PmisIgrala from "./igrala/PmisIgrala";
    import PmisIntro from "./intro/PmisIntro";
    import PmisPresentationContainer from "./presentation/PmisPresentationContainer";
    import DynamicModalDialog from './modals/DynamicModalDialog.vue'
    import AddNewSolutionModalDialog from './modals/AddNewSolutionModalDialog.vue'
    import StaticModalDialog from './modals/StaticModalDialog.vue'
    import SingleElementModalDialog from './modals/SingleElementModalDialog.vue'
    import MarkdownModalDialog from "./modals/MarkdownModalDialog";

    export default {
        name: "Main",
        components: {
            PmisPresentationContainer,
            PmisIntro,
            PmisIgrala,
            PmisTitle,
            PmisHeader,
            DynamicModalDialog,
            AddNewSolutionModalDialog,
            StaticModalDialog,
            MarkdownModalDialog,
            SingleElementModalDialog
        },
        computed: {
            getSolutions() {
                // alert(localStorage.getItem('new_solution'));
                return JSON.parse(localStorage.getItem('new_solution'));
                // return presentation["pmis-resitve"];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-fluid {
        max-width: 1900px;
    }

    hr {
        border-top: 1px solid rgba(207, 223, 235, 1);
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>
